module.exports = __webpack_public_path__ + "media/images/es/hero-bg-mobile-aa1c8ef78436e911463e888fd05d153f.jpg";